import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=b89870a0&scoped=true&"
import script from "./orderConfirm.vue?vue&type=script&lang=js&"
export * from "./orderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=b89870a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89870a0",
  null
  
)

export default component.exports